/**
 * クライアント側のコンバージョン計測ヘルパー。
 * GA4 / Meta Pixel が読み込まれている時のみイベントを送信する（無ければ無害な no-op）。
 * 応募・問い合わせの送信成功時に呼ぶ。
 */

type Gtag = (...args: unknown[]) => void;
type Fbq = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: Gtag;
    fbq?: Fbq;
  }
}

/** 応募・問い合わせなどのリード獲得を計測する */
export function trackLead(label: "application" | "contact"): void {
  if (typeof window === "undefined") return;
  try {
    window.gtag?.("event", "generate_lead", { lead_type: label });
    window.fbq?.("track", "Lead", { content_name: label });
  } catch {
    /* 計測失敗はユーザー体験に影響させない */
  }
}
